import {Validation} from './validation';

export const initValidation = () => {
  const validation = new Validation();
  validation.init();
};

